import { atom } from 'jotai';
export const $AdditionalScripts = atom({
    'tea-precollect': '',
    'slardar-precollect': '',
    'react-inline': '',
    'run-inline': '',
    remixContext: '',
});
$AdditionalScripts.debugLabel = '$AdditionalScripts';
